module.exports = __webpack_public_path__ + "img/case_template_blue.10c99d0f.svg";